import { columnWidthMap } from "@/services/contentful/components/GeometryTable/geometry-table.adapter";
import type { GeometryDataLiveEntry } from "../content-blocks/geometry-data-block.client.preview";
import { GeometryDataBlockClientPreview } from "../content-blocks/geometry-data-block.client.preview";
import type { GeometryDataBlockProps } from "./geometry-data-block";
import { fetchGeometryTableData } from "./geometry-data-block";

// Reverse of columnWidthMap: adapted numeric column width → raw Contentful label.
// Used to round-trip GeometryDataBlockProps.columnWidth back into GeometryDataLiveEntry.
const reverseColumnWidthMap = Object.fromEntries(
  Object.entries(columnWidthMap).map(([label, width]) => [width, label])
) as Record<
  (typeof columnWidthMap)[keyof typeof columnWidthMap],
  keyof typeof columnWidthMap
>;

export async function GeometryDataBlockPreview(
  props: Readonly<GeometryDataBlockProps>
) {
  const data = await fetchGeometryTableData(props);
  if (!data) {
    return null;
  }

  const liveEntry: GeometryDataLiveEntry = {
    __typename: "GeometryTable",
    sys: props.sys,
    internalName: props.internalName,
    anchorId: props.anchorId,
    productCodes: props.productCodes,
    showUnitToggle: props.showUnitToggle,
    defaultUnit: props.defaultUnit,
    containerWidth:
      props.columnWidth !== undefined
        ? reverseColumnWidthMap[props.columnWidth ?? columnWidthMap.wide]
        : undefined,
    // Microcopy fields — stored flat in liveEntry, nested in GeometryTableProps.microcopies
    title: props.microcopies?.title,
    frameSize: props.microcopies?.frameSize,
    sizesIn: props.microcopies?.sizesIn,
    unitMm: props.microcopies?.unitMm,
    unitInches: props.microcopies?.unitInches,
    // UiConfiguration — stored flat for field-by-field comparison in the client
    backgroundColor: props.backgroundColor,
    paddingTop: props.paddingTop,
    paddingBottom: props.paddingBottom,
  };

  return (
    <GeometryDataBlockClientPreview
      liveEntry={liveEntry}
      sysId={props.sys?.id}
      tableProps={data.tableProps}
    />
  );
}
